import { Fragment } from "react"

const newLineRegex = /(\r\n|\r|\n)/g

/**
 * Based on react-nl2br. Modified to not pass the key as a prop which causes a warning.
 */
const LineBreakBrText = ({text}) => {
  if (typeof text !== 'string') {
    return text;
  }

  const lines = text.split(newLineRegex)

  /**
   * To prevent breaking the layout with a single really long word.
   * <p>Based on https://stackoverflow.com/a/29202760</p>
   */
  const wordSplitter = (word, maxWordChunkLength = 20) => {
    if (word.length <= maxWordChunkLength) {
      return <Fragment>{word}</Fragment>
    }
    const numberOfChunks = Math.ceil(word.length / maxWordChunkLength);
    const chunks = new Array(numberOfChunks);

    for (let i = 0, j = 0; i < numberOfChunks; i++, j += maxWordChunkLength) {
      chunks[i] = word.substr(j, maxWordChunkLength);
    }
    return chunks.map( (chunk, i) => (
      <Fragment key={i}>
        {chunk}
        <wbr />
      </Fragment>
    ));
  } 

  return (
    <Fragment>
      {lines.map( (line, index) => (
        line.match(newLineRegex)
          ? <br key={"line"+index} />
          : <span key={"line"+index}>
              {line.split(' ').map( (word, j) => 
                <Fragment key={"word"+j}>
                  {wordSplitter(word)}{" "/*Add back the split spaces*/}
                </Fragment>)}
            </span>
      ))}
    </Fragment>
  )

}

export default LineBreakBrText;